(function () {
    var init = function () {
        hideOrShowAddIncomeButton();
        hideOrShowAddExpenseButton();
        setIncomeApproachFields();
        onBlurIncomeFields();
        enableDisableRentSQFTField();
    };

    var hideOrShowAddIncomeButton = function() {
        hideOrShowAddButton('income-source');
    };

    var hideOrShowAddExpenseButton = function() {
        hideOrShowAddButton('operating-expense');
    };

    var hideOrShowAddButton = function(selector) {
        var entries = $("." + selector + "-entry");
        var btn = $('.add-new-' + selector);
        if (entries.length < parseInt(btn.attr('data-limit'))) {
            btn.show();
        } else {
            btn.hide();
        }
    };

    var onBlurIncomeFields = function() {
        $(".on-blur-income").change(function() {
            ViewManager.save();
        });
    };

    var setIncomeApproachFields = function () {
        $(".income-approach-field:not(.field-rent-sq-ft,.field-monthly-income,.field-annual-income,.field-sq-ft)").keyup(_.debounce(
            ApproachCalculator.calculateIncomeApproach, 500));

        //Init events to calculate values upon entering other values
        ViewManager.calcIncomeValue();

        $(document).on('click', '.delete-new-income-source', function () {
            deleteIncomeSource.call(this);
        });

        $(document).on('click', '.add-new-income-source', function () {
            addIncomeSource();
            $('.tooltipped').tooltip({delay: 50});
        });

        $(document).on('click', '.delete-operating-expense', function () {
            deleteOperatingExpense.call(this);
        });

        $(document).on('click', '.add-new-operating-expense', function () {
            addOperatingExpense();
        });
    };

    function deleteIncomeSource() {
        var el = $(".income-source-entry");
        if (el.length !== 1) {
            $(this).closest('.income-source-entry').remove();
        } else {
            $(this).closest('.income-source-entry').find('input').val("");
        }

        ApproachCalculator.calculateIncomeApproach();

        hideOrShowAddIncomeButton();
    }

    function addIncomeSource() {
        var income_source_row = $('.income-source-entry').last().clone().addClass('no-total');

        income_source_row.find("input").val("");

        income_source_row.find("input").each(function (i, el) {
            $(el).removeAttr('readonly');
            $(el).removeAttr('data-id');
            $(el).removeClass('disabled-input');

            // if ($(el).attr('name') === 'evaluation[income_approach][income_source][index][square_feet]') {
            //     $(el).addClass('no-calc');
            // }

            // if ($(el).attr('name') === 'evaluation[income_approach][income_source][index][rent_sq_ft]') {
            if ($(el).hasClass('field-rent-sq-ft')) {
                // $(el).addClass('disabled-input');   
                $(el).attr("disabled", true); 
                $(el).parent().attr('data-position', 'top');
                $(el).parent().attr('data-delay', '50');
                $(el).parent().attr('data-limit', '7');
                $(el).parent().attr('data-tooltip', 'In order to edit this field, you must first input the SQ.FT.');
                $(el).parent().tooltip('show');
            }
        });

       
        income_source_row.find('.delete-new-income-source').removeClass('hide');

        $('.income-source-entry').last().after(income_source_row);

        $(".income-source").keyup(_.debounce(ApproachCalculator.calculateIncomeApproach, 500));

        // initializeMasks(true);

        hideOrShowAddIncomeButton();
        ViewManager.initIncomeSourceEvents(income_source_row);

        $('.income-source-entry').each(function () {
            var sq_ft = $(this).find($(".prop_space"));
            // var rent_sq_ft = $(this).find($("input[name='evaluation[income_approach][income_source][index][rent_sq_ft]"));
            let rent_sq_ft = $(this).find('.field-rent-sq-ft');
            sq_ft.on('change',function(){
                var sq_ft_value = $(this).val().trim();
                if(sq_ft_value != 0){
                    rent_sq_ft.prop("disabled",false);
                    rent_sq_ft.parent().tooltip('remove');
                }else{
                    rent_sq_ft.prop("disabled",true);
                    rent_sq_ft.addClass('disabled-input');
                    rent_sq_ft.parent().tooltip('show');
                }
            });
        });
    }

    function deleteOperatingExpense() {
        if ($(".operating-expense-entry").length !== 1) {
            $(this).closest('.operating-expense-entry').remove();
        } else {
            $(this).closest('.operating-expense-entry').find('input').val("");
        }
        ApproachCalculator.calculateIncomeApproach();

        hideOrShowAddExpenseButton();
    }

    function addOperatingExpense() {
        var income_source_row = $('.operating-expense-entry').last().clone();

        income_source_row.find("input").val("");

        $('.operating-expense-entry').last().after(income_source_row);

        $(".operating-expense").keyup(_.debounce(ApproachCalculator.calculateIncomeApproach, 500));

        initializeMasks(true);

        hideOrShowAddExpenseButton();
    }

    function enableDisableRentSQFTField(){
        $('.income-source-entry').each(function () {
            // var sq_ft = $(this).find($("input[name='evaluation[income_approach][income_source][index][square_feet]"));
            var sq_ft = $(this).find($(".prop_space"));
            // var rent_sq_ft = $(this).find($("input[name='evaluation[income_approach][income_source][index][rent_sq_ft]"));
            let rent_sq_ft = $(this).find('.field-rent-sq-ft');
            //onload
            var sq_ft_value = $(sq_ft).val().trim();
            if(sq_ft_value == 0){
                rent_sq_ft.prop("disabled",true);
                rent_sq_ft.addClass('disabled-input');
                rent_sq_ft.parent().attr('data-position', 'top');
                rent_sq_ft.parent().attr('data-delay', '50');
                rent_sq_ft.parent().attr('data-limit', '7');
                rent_sq_ft.parent().attr('data-tooltip', 'In order to edit this field, you must first input the SQ.FT.');
                rent_sq_ft.parent().tooltip('show');
            }

            sq_ft.on('change',function(){
                var sq_ft_value = $(this).val().trim();
                if(sq_ft_value != 0){
                    rent_sq_ft.prop("disabled",false);
                    // rent_sq_ft.removeClass('disabled-input');
                    rent_sq_ft.parent().tooltip('remove');
                }else{
                    rent_sq_ft.prop("disabled",true);
                    rent_sq_ft.addClass('disabled-input');
                    rent_sq_ft.parent().tooltip('show');
                }
            });
        });
    }

    if (window.IncomeApproach === undefined) {
        window.IncomeApproach = {};
    }

    IncomeApproach.init = init;
})();























